import { mapActions } from 'vuex'
import { mapState } from 'vuex/dist/vuex.common.js'

export default {
  props: {
    formasDePagamento: {
      type: Array,
      required: true
    },
    habilitarSalvarFormaDePagamentoPadrao: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('formaspagamento', ['formularioFormaDePagamentoCliente']),
    formasDePagamentoDefinido: {
      get () {
        return this.formularioFormaDePagamentoCliente.forma_pagamento_selecionado_padrao
      },
      set (pagamentoSelecionado) {
        this.ActionDefinirFormaPagamentoCliente({
          forma_pagamento_selecionado_padrao: pagamentoSelecionado,
          forma_pagamento_idselecionado: this.formasDePagamento.find(forma => forma.nome === pagamentoSelecionado).id
        })
      }
    }
  },
  methods: {
    salvarInformacoes () {
      this.$emit('salvarInformacoes', this.formularioFormaDePagamentoCliente.forma_pagamento_selecionado_padrao)
    },
    ...mapActions('formaspagamento', ['ActionDefinirFormaPagamentoCliente'])
  },
  mounted () {}
}
